module.exports = __webpack_public_path__ + "img/no-tags-new.c4c75a6e.svg";